import { render, staticRenderFns } from "./batchMode.vue?vue&type=template&id=312e27c7"
import script from "./batchMode.vue?vue&type=script&lang=js"
export * from "./batchMode.vue?vue&type=script&lang=js"
import style0 from "./batchMode.vue?vue&type=style&index=0&id=312e27c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports